export default __webpack_public_path__ + "static/media/1761.a6baae38.png";